import React from 'react'
import ReactDOM from 'react-dom/client'
import { ConfigProvider } from 'antd'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'

// ── Sentry Initialisation ──────────────────────────────────────────────────
// Must be called before ReactDOM.createRoot so Sentry can instrument
// the React component tree and capture render errors.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE || 'production',
  release: import.meta.env.VITE_APP_VERSION || 'bid-admin-app@1.0.0',
  integrations: [
    Sentry.browserTracingIntegration(),        // Captures route-change performance spans
    Sentry.replayIntegration({
      maskAllText: false,                      // keep text visible in replays
      blockAllMedia: false,
    }),
  ],
  // Performance: sample 10% of transactions in production
  tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE 
    ? parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) 
    : (import.meta.env.PROD ? 0.1 : 1.0),
  // Session Replay: record full session when an error occurs
  replaysSessionSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE
    ? parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE)
    : 0.05,
  replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE
    ? parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE)
    : 1.0,
  // Enable whenever DSN is provided (dev/staging/production)
  enabled: Boolean(import.meta.env.VITE_SENTRY_DSN),
  beforeSend(event) {
    // Sanitize any sensitive headers or fields before sending
    if (event.request?.headers) {
      delete event.request.headers['Authorization'];
      delete event.request.headers['authorization'];
    }
    return event;
  },
})
// ──────────────────────────────────────────────────────────────────────────

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#7c3aed',
          borderRadius: 6,
        },
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>,
)
